import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import NatureTrailWheelComponent from './js/nature-trail-wheel.component';
import NatureTrailImageComponent from './js/nature-trail-image.component';

ComponentsFactory.getInstance().define('nature-trail-wheel', NatureTrailWheelComponent);
ComponentsFactory.getInstance().define('nature-trail-image', NatureTrailImageComponent);
